import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService, FormatStyle } from './date-time.service';

/**
 * Templates-friendly formatter that delegates to {@link DateTimeService}.
 *
 * Usage:
 *   {{ msg.timestamp | appDate: 'time' }}      → "1:27 AM"
 *   {{ session.created_at | appDate: 'date' }} → "13 May 2026"
 *   {{ session.last_active | appDate }}        → "13 May 2026, 1:27 AM" (datetime)
 *   {{ session.last_active | appDate: 'relative' }} → "3m ago"
 *
 * Pipe is `pure: true` (default) — values are immutable strings/Dates, so
 * Angular safely caches the rendered output between change-detection cycles.
 */
@Pipe({ name: 'appDate', standalone: false })
export class AppDatePipe implements PipeTransform {
  constructor(private readonly dt: DateTimeService) {}

  transform(
    value: Date | string | null | undefined,
    style: FormatStyle = 'datetime',
  ): string {
    if (value == null || value === '') { return ''; }
    switch (style) {
      case 'time':     return this.dt.formatTime(value);
      case 'date':     return this.dt.formatDate(value);
      case 'datetime': return this.dt.formatDateTime(value);
      case 'relative': return this.dt.formatRelative(value);
      case 'iso':      return this.dt.toIsoUtc(value);
      default:         return this.dt.formatDateTime(value);
    }
  }
}
